import post from '../../../../fns/http/post'
import getHeaders from './headers/index'

const loadMap = (data, { urls, locale, headers, sessionId, responseProxy }) => {
    return post(`${urls.base.se}/search/product/map?size=100`, data, null, getHeaders({ locale, headers }), { responseProxy })
}
export default loadMap
